import { faList, faTh } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaCheck, FaClock, FaTimes } from 'react-icons/fa';
import { MdKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import {
    EVENTS_BASE_URL,
    EVENT_FORMAT_URL,
    PROCESS_INVITATION,
    GET_ALL_EVENT_BY_FAMILY,
    GET_ALL_EVENT_BY_FAMILY_SUGGESTED
} from '../ApiDetails.js';
import defaultImage from "../../images/default.jpg";
import ConfirmationModalDecline from "../GetEventMarsComplete.jsx/ConfirmationModal";
import AdditionalPopupDecline from "../GetEventMarsComplete.jsx/AdditionalPopup";
import ConfirmationModalAccept from "../GetEventMarsComplete.jsx/ConfirmationModalAccept";
import AdditionalPopupAccept from "../GetEventMarsComplete.jsx/AdditionalPopupAccept";
import ConfirmationModalTentative from "../GetEventMarsComplete.jsx/ConfirmationModalTentative";
import AdditionalPopupTentative from "../GetEventMarsComplete.jsx/AdditionalPopupTentative";

function LeftContainerHome({
    setFilteredEventDates,
    filters,
    searchQuery,
    selectedYear,
    selectedRegion
}) {
    const [statuses, setStatuses] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [events, setEvents] = useState([]);
    const [selectedDate, setSelectedDate] = useState("");
    const [sortBy, setSortBy] = useState("Newest");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const itemsPerPage = 6;
    const [selectedEndDate, setSelectedEndDate] = useState("");
    const [filteredEvents, setFilteredEvents] = useState([]);
    const [eventFormatFilters, setEventFormatFilters] = useState([]);
    const [selectedEventFormat, setSelectedEventFormat] = useState("All");
    const [viewMode, setViewMode] = useState("card");
    const [eventFormData, setEventFormData] = useState({
        eventID: 0,
        requestedBy: "",
        eventTitle: "",
        associateSegment: "",
        email: "",
        phone: "",
        phoneCode: "",
        eventDate: "",
        siteCode: "",
        countryName: "",
        stateName: "",
        cityName: "",
        eventVenueName: "",
        eventAddress: "",
        eventType: "",
        eventFormat: "",
        totalAttendees: 0,
        petcareAttendees: 0,
        schedule: {
            visitSummary: "",
            draftItinerary: "",
        },
        maxFamilyNum: false,
        familyNum: 1,
        specificFamilyMem: false,
        nameOfMem: "",
        IsScheduleChange: false,
        lastVisit: "",
        associates: "",
        IsImageCover: false,
        eventId: 0,
        eventStatus: "Draft",
        eventEndDate: "",
        otherSiteCode: "",
        isDateFlexible: false,
    });

    const handleEventFormatChange = (e) => {
        setSelectedEventFormat(e.target.value);
    };

    const [isWide, setIsWide] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia("(min-width: 1024px)");

        // Set initial value
        setIsWide(mediaQuery.matches);

        // Listener for changes
        const handler = (e) => {
            setIsWide(e.matches);
            if (!e.matches) setViewMode("card");
        };
        mediaQuery.addEventListener("change", handler);

        return () => mediaQuery.removeEventListener("change", handler);
    }, []);

    useEffect(() => {
        const fetchEventFormat = async () => {
            try {
                const eventFormatResponse = await axios.get(EVENT_FORMAT_URL);
                setEventFormatFilters(eventFormatResponse.data);
            } catch (error) {
                console.error("Error fetching eventFormat data:", error);
            }
        };

        fetchEventFormat();
    }, []);

    useEffect(() => {
        const fetchEvents = async () => {
            // Fetch data from both APIs concurrently
            Promise.all([
                axios.get(GET_ALL_EVENT_BY_FAMILY),
                axios.get(GET_ALL_EVENT_BY_FAMILY_SUGGESTED)])
                .then(([familyResponse, suggestedResponse]) => {
                    // Filtering events to exclude "Draft" and "Under Review" statuses is done on the backend side (events of these statuses only visible if the user is the requester)
                    const filteredEvents = [...familyResponse.data, ...suggestedResponse.data];

                    // Set filtered events to state
                    setEvents([...filteredEvents.map(event => {
                        if (event.siteCode==="OFF") event.onelinerAddress = event.eventAddress.replace("\r\n", " ").replace("\r", " ").replace("\n", " "); else {
                            if ((event.cityName!=="") && (event.cityName!=="null") && (event.cityName!==null)) event.onelinerAddress = event.cityName;
                            if ((event.stateName!=="") && (event.stateName!=="null") && (event.stateName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.stateName;
                            if ((event.countryName!=="") && (event.countryName!=="null") && (event.countryName!==null)) event.onelinerAddress += (event.onelinerAddress!=="" ? ", " : "") + event.countryName;
                        }
                        return event;
                    })]);

                    const uniqueStatuses = ["Open event", "Attendance confirmed", "Pending documentation", "Completed", "Cancelled"];
                    setStatuses(uniqueStatuses);

                    // Extract "Open Event" dates for filtering
                    const openEventDates = filteredEvents
                        .filter((event) => event.eventStatus === "Open event")
                        .map((event) => new Date(event.eventDate));

                    setSelectedStatuses(uniqueStatuses);
                    setFilteredEventDates(openEventDates);
                })
                .catch((error) => {
                    console.error('Error fetching events:', error);
                    setError(error.message);
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        if (loading) fetchEvents();
    }, []);


    const isDateInRange = (
        eventDate,
        eventEndDate,
        selectedDate,
        selectedEndDate
    ) => {
        const eventStart = new Date(eventDate);
        const eventEnd = new Date(eventEndDate || eventDate);

        const selectedStart = selectedDate ? new Date(selectedDate) : null;
        const selectedEnd = selectedEndDate ? new Date(selectedEndDate) : null;

        return (
            (!selectedStart || eventStart >= selectedStart) &&
            (!selectedEnd || eventEnd <= selectedEnd)
        );
    };


    const ProcessEventInvitationForEvent = async (eventId, status, comment) => {
        try {
            // Prepare data for processing invitation
            const data = new FormData();
            data.append("status", status);
            data.append("comment", comment);

            // Call Process Invitation API
            axios.post(`${PROCESS_INVITATION}/${eventId}`, data)
                .then(response => {
                    if (response.data <= 0) {
                        alert("Error in processing invitation");
                    }
                })
                .catch(error => {
                    console.error('Error in processing invitation: ', error);
                    alert("Error in processing invitation");
                });
        } catch (error) {
            console.error("Error in processing invitation:", error);
            alert("Error in processing invitation:", error);
        }
    };

      const [modalEventId, setModalEventId] = useState();
      const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
      const [isAcceptModalOpen, setIsAcceptModalOpen] = useState(false);
      const [isTentativeModalOpen, setIsTentativeModalOpen] = useState(false);
      const [isAdditionalPopupDeclineOpen, setIsAdditionalPopupDeclineOpen] = useState(false);
      const [isAdditionalPopupAcceptOpen, setIsAdditionalPopupAcceptOpen] = useState(false);
      const [isAdditionalPopupTentativeOpen, setIsAdditionalPopupTentativeOpen] = useState(false);

      //for decline invitation
      const handleDeclineSaveClick = (comment) => {
        ProcessEventInvitationForEvent(modalEventId,"Declined", comment);
        setIsDeclineModalOpen(false);
        setIsAdditionalPopupDeclineOpen(true);
      };

      const handleDeclineCancelClick = (e) => {
        e.preventDefault();
        setIsDeclineModalOpen(false);
      };

      const handleAdditionalPopupDeclineClose = () => {
        setIsAdditionalPopupDeclineOpen(false);
        window.location.reload();
      };

      // for accept invitation
      const handleAcceptSaveClick = (comment) => {
        ProcessEventInvitationForEvent(modalEventId,"Confirmed", comment);
        setIsAcceptModalOpen(false);
        setIsAdditionalPopupAcceptOpen(true);
      };

      const handleAcceptCancelClick = (e) => {
        e.preventDefault();
        setIsAcceptModalOpen(false);
      };

      const handleAdditionalPopupAcceptClose = () => {
        setIsAdditionalPopupAcceptOpen(false);
        window.location.reload();
      };

      // for tentative invitation

      const handleTentativeSaveClick = (comment) => {
        ProcessEventInvitationForEvent(modalEventId,"Tentative", comment);
        setIsTentativeModalOpen(false);
        setIsAdditionalPopupTentativeOpen(true);
      };

      const handleTentativeCancelClick = (e) => {
        e.preventDefault();
        setIsTentativeModalOpen(false);
      };

      const handleAdditionalPopupTentativeClose = () => {
        setIsAdditionalPopupTentativeOpen(false);
        window.location.reload();
      };

    const getStatus = (eventId) => {
        // If not both users have accepted, return the current event status
        return (
            events.find((event) => event.id === eventId)?.eventStatus || "Open event"
        );
    };

    useEffect(() => {
        if (events) {
            const eventsFiltred = events
                .map((event) => {
                    const dynamicStatus = getStatus(event.id);
                    return { ...event, eventStatus: dynamicStatus };
                })
                // Step 2: Filter based on the dynamic eventStatus and other filters
                .filter((event) => {
                    // Check if event matches selected statuses
                    const statusMatch =
                        selectedStatuses.length > 0 &&
                        selectedStatuses.includes(event.eventStatus);

                    // Continue with other filters like date or search query
                    const dateMatch =
                        (selectedDate === "" && selectedEndDate === "") ||
                        isDateInRange(
                            event.eventDate,
                            event.eventEndDate,
                            selectedDate,
                            selectedEndDate
                        );

                    const searchMatch =
                        searchQuery === "" || searchQuery === undefined ||
                        event.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                        event.eventVenueName?.toLowerCase().includes(searchQuery.toLowerCase());
                    const yearMatch =
                        selectedYear === null ||
                        new Date(event.eventDate).getFullYear() === selectedYear ||
                        new Date(event.eventDate).getFullYear() === (selectedYear + 1);

                    const regionMatch =
                        selectedRegion === "" ||
                        (event.region &&
                            event.region.toLowerCase() === selectedRegion.toLowerCase());

                    const myEventsMatch =
                        filters.myEvents && event.category === "myEventDtos";
                    const otherFamilyEventsMatch =
                        filters.otherFamilyEvents && event.category === "otherFamilyEventDtos";
                    const needsFamilyMembersMatch =
                        filters.needsFamilyMembers && event.category === "needFamilyMemberDtos";
                    const eventFormatFilter = selectedEventFormat === "All" || event.eventFormat === selectedEventFormat;
                    return (
                        statusMatch &&
                        dateMatch &&
                        eventFormatFilter &&
                        searchMatch &&
                        yearMatch &&
                        regionMatch &&
                        (
                            myEventsMatch ||
                            otherFamilyEventsMatch ||
                            needsFamilyMembersMatch
                        )
                    );
                });
            const filteredDates = eventsFiltred.map((event) => ({
                eventTitle: event.name,
                eventDate: event.eventDate,
                eventStatus: event.eventStatus,
                eventEndDate: event.eventEndDate,
                requestedBy: event.requestedBy,
                createdDate: event.createdDate
            }));

            setFilteredEvents(eventsFiltred);
            setFilteredEventDates(filteredDates);
        }
    }, [events, filters, selectedEventFormat, searchQuery, selectedYear, selectedRegion, sortBy, selectedDate, selectedStatuses, selectedEndDate, currentPage, statuses]);

    const sortedEvents = [...filteredEvents].sort((a, b) => {
        if (sortBy === "Newest") {
            return new Date(b.eventDate) - new Date(a.eventDate);
        } else if (sortBy === "Oldest") {
            return new Date(a.eventDate) - new Date(b.eventDate);
        } else if (sortBy === "A to Z") {
            return a.name.localeCompare(b.name);
        } else if (sortBy === "Z to A") {
            return b.name.localeCompare(a.name);
        }
        return 0;
    });

    const totalPages = Math.ceil(sortedEvents.length / itemsPerPage);

    const currentEvents = sortedEvents.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePageClick = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const getPageNumbers = () => {
        const pageNumbers = [];
        const maxPageNumbersToShow = 5;

        let startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
        let endPage = Math.min(totalPages, startPage + maxPageNumbersToShow - 1);

        if (endPage - startPage + 1 < maxPageNumbersToShow) {
            startPage = Math.max(1, endPage - maxPageNumbersToShow + 1);
        }
        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const handleStatusClick = (status) => {
        setSelectedStatuses((prevStatuses) =>
            prevStatuses.includes(status)
                ? prevStatuses.filter((s) => s !== status)
                : [...prevStatuses, status]
        );
    };

    return (
        <div
            className="leftcontainer d-flex flex-column progress-bar bg-white rounded-end"
            aria-valuenow="60"
            aria-valuemin="0"
            aria-valuemax="100"
            style={{ minHeight: "500px" }}
        >
            <div className="leftsearchbox">
                <div className="container-fluid d-flex align-items-center">
                  <div className="status-buttons mb0">
                    <h6 className="calendar-headerh6 mr-2">Status</h6>
                        {statuses.map((status) => (
                            <>
                                <div
                                    key={status}
                                    className={`status-button ${selectedStatuses.includes(status) ? "selected" : ""}`}
                                    onClick={() => handleStatusClick(status)}
                                >
                                    <span>{status}</span>
                                </div>
                            </>
                        ))}
                    </div>
                    {isWide ? (
                        <div className="col-md-1">
                            <FontAwesomeIcon
                                icon={viewMode === "card" ? faList : faTh}
                                onClick={() => setViewMode(viewMode === "card" ? "list" : "card")}
                                style={{ cursor: 'pointer', fontSize: '20px', marginTop: '5px' }}
                            />
                        </div>
                    ) : ("")}
                </div>
                <br/>
                <div className="container-fluid align-items-center">
                    <div className="row adminPageSearchDateSpacing">
                        <div className="col-md-2 d-flex align-items-center">
                                <div className="input-group mb-1">
                                    <label
                                        className="input-group-text input-group-text-custom"
                                        htmlFor="sortBy"
                                    >
                                        Sort By
                                    </label>
                                    <select
                                        className="form-control-custom rounded form-select"
                                        aria-label="Sort By"
                                        id="sortBy"
                                        value={sortBy}
                                        onChange={(e) => setSortBy(e.target.value)}
                                    >
                                        <option value="Newest">Newest</option>
                                        <option value="Oldest">Oldest</option>
                                        <option value="A to Z">A to Z</option>
                                        <option value="Z to A">Z to A</option>
                                    </select>
                                </div>
                        </div>
                        <div className="col-md-2 d-flex align-items-center">
                                <div className="input-group mb-0">
                                <label
                                    htmlFor="eventFormat"
                                    className="input-group-text input-group-text-custom"
                                    style={{ whiteSpace: "nowrap", }}
                                >
                                    EVENT FORMAT
                                </label>
                                <select
                                    className="form-control-custom rounded form-select"
                                    style={{ width: "130px", }}
                                    aria-label="Event Format"
                                    id="eventFormat"
                                    value={selectedEventFormat}
                                    onChange={handleEventFormatChange}
                                >
                                    <option value="All">All</option>
                                    {eventFormatFilters.length > 0 &&
                                        eventFormatFilters.map((formatName, index) => (
                                            <option key={index} value={formatName}>
                                                {formatName}
                                            </option>
                                        ))}
                                </select>
                                </div>
                        </div>
                        <div className="col-md-4 d-flex align-items-center">
                                <div className="input-group mb-0">
                                <label
                                    htmlFor="dateInput"
                                    className="input-group-text input-group-text-custom"
                                >
                                    Date Interval
                                </label>
                                <div
                                    style={{ display: "flex", alignItems: "center", gap: "10px" }}
                                    className="requestorMainPageDateInterval"
                                >
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control selectDateInput"
                                        id="dateInput"
                                        value={selectedDate}
                                        onChange={(e) => setSelectedDate(e.target.value)}
                                    />
                                    <span style={{ fontWeight: "bold" }}>to</span>
                                    <input
                                        type="date"
                                        className="form-control-custom rounded form-control selectDateInput"
                                        id="dateInput1"
                                        value={selectedEndDate}
                                        onChange={(e) => setSelectedEndDate(e.target.value)}
                                    />
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="listitems">
                <div className="row card-group text-wrap text-start m-2 flex-wrap">
                    {currentEvents.map((event) => (
                        <div key={event.id} className={viewMode === 'card' ? 'col-md-4 p-2' : 'list-group'}>
                            <div className="card-event" onClick={() => { const url = `/getDetailMarsComplete/${event.id}`; navigate(url); }}>
                                <div className={`card rounded ${viewMode === 'card' ? 'align-items-stretch' : 'list-group-item'} list-card`}>
                                    <div className={viewMode === 'card' ? "card-img-container" : "col-md-1 d-flex justify-content-between align-items-start d-none"} >
                                        {event.coverImage
                                            ? <img
                                                className={viewMode === 'card' ? "card-img-top-custom card-img-top rounded" : "d-flex justify-content-between align-items-start"}
                                                src={event.coverImage ?? defaultImage}
                                                alt={event.name} />
                                            : <div className='card-noimg-text'>
                                                <span className='line-clamp-3'>{event.name}</span>
                                            </div>}
                                    </div>
                                    <div className={`card-body-custom card-body ${viewMode === 'list' ? 'list-body col-md-8' : ''}`}>
                                        <h6 className={viewMode === 'list' ? 'list-header-custom line-clamp-2' : 'card-header-custom line-clamp-2'} title={event.name}>
                                            {event.name}
                                        </h6>
                                        <div className={viewMode === 'list' ? 'list-text-custom' : 'event-card-text-custom'}>
                                            {(event.guests.filter(guest => guest.status === 'Confirmed').length > 0) && (
                                                <>
                                                    with <b>{event.guests.filter(guest => guest.status === 'Confirmed').map(guest => `${guest.user.firstName} ${guest.user.lastName}`).join(', ')}</b>
                                                </>
                                            )}

                                            {((event.eventStatus === "Open event") && (
                                               (event.guests.filter(guest => guest.status === 'Confirmed').length < event.familyNum)
                                            )) && (
                                                <>
                                                    <div>Still accepting Family members <b>{event.guests.filter(guest => guest.status === 'Confirmed').length} out of {event.familyNum}</b></div>
                                                </>
                                            )}
                                            <div>
                                                <b>
                                                    {new Date(event.eventDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} to{" "}
                                                    {new Date(event.eventEndDate).toLocaleDateString('en-US', {timeZone: 'UTC'})} •{" "}
                                                    {event.onelinerAddress}
                                                </b>
                                            </div>
                                            <br />
                                            <span>
                                                Created by {event.requestedBy} on{" "}
                                                {new Date(event.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="card-footer-custom card-footer">
                                    </div>
                                    <div>
                                        {viewMode === "card" ?
                                            <div className='card-footer card-footer-custom'>
                                                <Link
                                                    to={`/getDetailMarsComplete/${event.id}`}
                                                    className={`card-footer-button btn rounded-pill ${getStatus(event.id)}`}>
                                                    {getStatus(event.id).toUpperCase()}
                                                </Link>
                                                <span
                                                    className="float-right-custom"
                                                    style={{ display: "flex" }}
                                                >
                                                    <div className="guest-actions">
                                                        <button
                                                            className={`btn-remove ${event.userStatus === 'Declined' ? 'Declined' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsDeclineModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaTimes />
                                                        </button>
                                                        <button
                                                            className={`btn-timer ${event.userStatus === 'Tentative' ? 'Tentative' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsTentativeModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaClock />
                                                        </button>
                                                        <button
                                                            className={`btn-confirm ${event.userStatus === 'Confirmed' ? 'Confirm' : ''}`}

                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsAcceptModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaCheck />
                                                        </button>
                                                    </div>
                                                </span>
                                            </div>
                                            :
                                            <div className='card-footer card-footer-custom event-btn col-md-4'>
                                                <Link
                                                    to={`/getDetailMarsComplete/${event.id}`}
                                                    className={`card-footer-button btn rounded-pill ${getStatus(event.id)}`}>
                                                    {getStatus(event.id).toUpperCase()}
                                                </Link>
                                                <div>
                                                    <div className="guest-actions">
                                                        <button
                                                            className={`btn-remove ${event.userStatus === 'Declined' ? 'Declined' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsDeclineModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaTimes />
                                                        </button>
                                                        <button
                                                            className={`btn-timer ${event.userStatus === 'Tentative' ? 'Tentative' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsTentativeModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaClock />
                                                        </button>
                                                        <button
                                                            className={`btn-confirm ${event.userStatus === 'Confirmed' ? 'Confirm' : ''}`}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setModalEventId(event.id);
                                                                setIsAcceptModalOpen(true);    
                                                            }}
                                                        >
                                                            <FaCheck />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


            <div className="paging align-items-center">
                <span className="centered-text">
                    {(currentPage - 1) * itemsPerPage + 1}-
                    {Math.min(currentPage * itemsPerPage, sortedEvents.length)} OF{" "}
                    {sortedEvents.length} ELEMENTS
                </span>
                <nav>
                    <ul
                        className="pagination justify-content-end"
                        style={{ marginBottom: "17px", cursor: "pointer" }}
                    >
                        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                            <span
                                className="page-link"
                                onClick={() => handlePageClick(currentPage - 1)}
                                style={{ fontSize: "12px", padding: "4px 8px" }}
                            >
                                <MdKeyboardArrowLeft />
                            </span>
                        </li>
                        {getPageNumbers().map((number) => (
                            <li
                                key={number}
                                className={`page-item ${currentPage === number ? "active" : ""
                                    }`}
                            >
                                <span
                                    className="page-link"
                                    onClick={() => handlePageClick(number)}
                                    style={{ fontSize: "12px", padding: "4px 8px" }}
                                >
                                    {number}
                                </span>
                            </li>
                        ))}
                        <li
                            className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                }`}
                        >
                            <span
                                className="page-link"
                                onClick={() => handlePageClick(currentPage + 1)}
                                style={{ fontSize: "12px", padding: "4px 8px" }}
                            >
                                <MdOutlineKeyboardArrowRight />
                            </span>
                        </li>
                    </ul>
                </nav>
            </div>
            <ConfirmationModalAccept
                isOpen={isAcceptModalOpen}
                onClose={() => setIsAcceptModalOpen(false)}
                onSave={(comment) => handleAcceptSaveClick(comment)}
                onCancel={handleAcceptCancelClick}
                commentMandatory={false}
                placeHolderText="I accept this invitation."
            />
            <AdditionalPopupAccept
                isOpen={isAdditionalPopupAcceptOpen}
                onClose={handleAdditionalPopupAcceptClose}
            />
            <ConfirmationModalTentative
                isOpen={isTentativeModalOpen}
                onClose={() => setIsTentativeModalOpen(false)}
                onSave={(comment) => handleTentativeSaveClick(comment)}
                onCancel={handleTentativeCancelClick}
                commentMandatory={false}
                placeHolderText="I might accept this invitation."
            />
            <AdditionalPopupTentative
                isOpen={isAdditionalPopupTentativeOpen}
                onClose={handleAdditionalPopupTentativeClose}
            />
            <ConfirmationModalDecline
                isOpen={isDeclineModalOpen}
                onClose={() => setIsDeclineModalOpen(false)}
                onSave={(comment) => handleDeclineSaveClick(comment)}
                onCancel={handleDeclineCancelClick}
                commentMandatory={true}
                placeHolderText="I decline this invitation."
            />
            <AdditionalPopupDecline
                isOpen={isAdditionalPopupDeclineOpen}
                onClose={handleAdditionalPopupDeclineClose}
            />
        </div>
    );
}

export default LeftContainerHome;